/**
 * Deliberately generic: the backend answers 401 both for an unknown email and for a wrong
 * password, so the message must not let anyone tell those two apart.
 */
export const INCORRECT_CREDENTIALS =
  'The email address or password you entered is incorrect. Please check your information and try again.'

/** Support address shown to users who cannot get into their account. */
export const SUPPORT_EMAIL = 'contact@proactivememoryservices.com'

/**
 * Why a sign-in was refused with 403. The backend names the reason; the wording is the client's
 * and differs by account type, so each case says who can restore access.
 */
export type LoginRefusalReason = 'inactive' | 'subscription_expired' | 'license_expired'

export const ACCOUNT_INACTIVE = 'Your account is currently inactive.'

export const SUBSCRIPTION_EXPIRED =
  'Your account is currently inactive. To restore access, please enter'

export const LICENSE_EXPIRED =
  'Your account is currently inactive because of an expired license. Please contact your employer to extend the license and restore access.'

/**
 * How many failed sign-in attempts in a row with the same email before the plain message is
 * replaced with one pointing at Forgot Password and support.
 */
export const FAILED_SIGN_IN_ATTEMPTS_BEFORE_HINT = 3
